// Published as `flowrunner-cli/runtime`. Bundled rather than shipped raw because it sits on
// @flowrunner/flow-extension-runner and @flowrunner/jsdoc-parser, which are devDependencies; `jsdoc` and
// `requizzle` stay real dependencies since the JSDoc parser shells out to them at runtime.
//
// This code IS the deployed definition, so a reimplementation in a consumer repo can drift — which makes a
// parity report green but meaningless. Import from here instead.
//
// Importing installs `global.Flowrunner`. Entry-point paths are `require`d, so they must be absolute.

export type { ExtensionVersion, RunServiceMethodData } from '@flowrunner/flow-extension-runner'
export {
  buildServiceDefinition,
  detectVersion,
  getServiceConfigs,
  runServiceMethod,
} from '@flowrunner/flow-extension-runner'

// Registration is a require-time side effect, so this alone is a no-op against a cached module: detectVersion
// then reports a v2 service as `v1` and buildServiceDefinition returns null, silently. Pair it with
// `delete require.cache[require.resolve(entryPoint)]`.
export { resetRegistry } from '@flowrunner/flow-extension-runner/v2'

// getServiceConfigs and buildServiceDefinition return types. SharedExtensionDefinition is NOT interchangeable
// with the console's same-named model that parseJsDocToServiceJson returns — unassignable in both directions
// (`serviceInfo.integrationIcon`, `metaInfo.sampleResultLoader`). Type a v1 parse with
// `ReturnType<typeof parseJsDocToServiceJson>`.
export type { ConfigItem, SharedExtensionDefinition } from '@flowrunner/flow-extension-runner/v2'
export { parseJsDocToServiceJson } from '@flowrunner/jsdoc-parser'
